import React, { useState } from 'react'
import { useUser } from '../../utils/userContext';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import useConfiguration from '../../utils/ConfigurationContext';


const Exitrequest = () => {
    const [subject, setSubject] = useState('');
    const [reason, setReason] = useState('');
    const [description, setDescription] = useState('');
    const { user } = useUser();
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const handleErrors = useHandleErrors();
    const token = localStorage.getItem("token");
    const config = useConfiguration();


    const options = [
        { value: 'Better Employment Conditions', label: 'Better Employment Conditions' },
        { value: 'Career Prospect', label: 'Career Prospect' },
        { value: 'Dessertion', label: 'Dessertion' },
        { value: 'Dismissed', label: 'Dismissed' },
        { value: 'Dissatisfaction on Job', label: 'Dissatisfaction on Job' },
        { value: 'Emigrating', label: 'Emigrating' },
        { value: 'Health', label: 'Health' },
        { value: 'Higher Pay', label: 'Higher Pay' },
        { value: 'Personality Conflicts', label: 'Personality Conflicts' },
        { value: 'Retirement', label: 'Retirement' },
        { value: 'Retrenchment', label: 'Retrenchment' }
    ];

    const ClearIndicator = () => null;

    const handleChange = selectedOption => {
        setReason(selectedOption);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        if (!subject) {
            toast.error("Subject is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!reason) {
            toast.error("Reason is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!description) {
            toast.error("Description is required.", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        const postData = {
            EmployeeId: user?.EmployeeId,
            EmployeeName: user?.FirstName + " " + user?.LastName,
            EmployeeEmail: user?.OfficialEmail,
            Subject: subject,
            Reason: reason?.value,
            Description: description,
            Status: "Submitted"
        };

        try {
            const path = "/offBoardRequest";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.post(URL, postData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (response.status === 200) {
                setShowModal(true)
                setSubject("")
                setReason("")
                setDescription("")
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);

    };
    const handleClear = () => {
        setSubject("")
        setReason("")
        setDescription("")
    };

    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div class="content-page">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col">
                            <h3 class="title mb-2">Exit Request</h3>
                        </div>
                        <div class="col-auto">
                            <Link to={'/ProfileSearch'} data-extra-toggle="tab" data-target="#self-service-pan" class="btn btn-primary mt-lg-0 mt-4"><i class="ri-user-search-line"></i> Profile Search</Link>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-8">
                            <div className="card mb-4">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="mt-2">Employee ID</label>
                                        </div>
                                        <div className="col">
                                            <input type="text" className="form-control-plaintext" value={user?.EmployeeId} readOnly />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="mt-2">Employee Name</label>
                                        </div>
                                        <div className="col">
                                            <input type="text" className="form-control-plaintext" value={user?.FirstName + " " + user?.LastName} readOnly />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="mt-2">Employee Email</label>
                                        </div>
                                        <div className="col">
                                            <input type="email" className="form-control-plaintext" value={user?.OfficialEmail} readOnly />
                                        </div>
                                    </div>

                                    <hr />
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="subject" className="required">Subject</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={subject}
                                                        onChange={(e) => setSubject(e.target.value)}
                                                        required
                                                        placeholder="Enter subject"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="category" className="required">Reason</label>
                                                    <Select
                                                        className="react-select-container"
                                                        classNamePrefix="react-select"
                                                        value={reason}
                                                        onChange={handleChange}
                                                        options={options}
                                                        isClearable
                                                        placeholder="Select a reason..."
                                                        components={{ ClearIndicator }} // Hides the clear indicator
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-12 col-md-12">
                                                <div className="form-group">
                                                    <label htmlFor="description" className="required">Description</label>
                                                    <textarea className="form-control" rows="10" value={description} onChange={(e) => setDescription(e.target.value)} required></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="card ww-app-bg">
                                <div className="card-body">
                                    <span><i className="ri-user-2-fill"></i></span>
                                </div>
                            </div>
                            <div className="card mb-4">
                                <div className="card-body">
                                    <h4 className="mb-2">Know about your HR?</h4>
                                    <p>Click the below icon and refer all our policies related to your needs.</p>
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-auto text-center">
                                            <Link to={'/policies'} className="info-icon-box" title="Policies" rel="tooltip"><i className="ri-file-text-line"></i></Link>
                                        </div>
                                    </div>

                                    <div className="row align-items-center border-top">
                                        <div className="col-12">
                                            <p className="mt-3">Quickly get in touch us for more queries.</p>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-1"><i className="ri-mail-send-fill"></i></div>
                                        <div className="col">{config?.hrEmail}</div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-1"><i className="ri-message-3-line"></i></div>
                                        <div className="col">Chat with us</div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col text-center"><Link to={'/HrConnect'} className="btn btn-secondary mt-lg-0 mt-4" title="Update Information" rel="tooltip"><i className="ri-user-2-fill"></i> Contact Us</Link></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row fixed-footer">
                <div class="col-lg-12 text-center">
                    <button type="reset" class="btn btn-light" onClick={handleClear}>Clear</button>
                    <button type="submit" class="btn btn-primary" data-toggle="modal" data-target="#cautionModal" onClick={handleSubmit}>Submit <i class="ri-checkbox-circle-line"></i></button>
                </div>
            </div>
            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="successModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                        <div className="modal-content shadow success-modal">
                            <div className="modal-header py-2">
                                <h6 className="modal-title" id="successModalModalLabel">Success!</h6>
                                <button className="close" type="button" aria-label="Close" onClick={handleCloseModal}>
                                    <span aria-hidden="true"><i className="ri-close-circle-fill font-size-20"></i></span>
                                </button>
                            </div>
                            <div className="modal-body pb-5">
                                <div className="row">
                                    <div className="col-12 text-success text-center"><i className="ri-checkbox-circle-fill"></i></div>
                                    <div className="col-12 text-center">Exit Requested successfully.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default Exitrequest
